import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATklEQVR42lWM0QkAIQxD3X8bcQ+dQvCjlP6WtuSwxx0aCITwkoJDqgozOysvf3LHnBNrrcwXsFe9d7TWUGvFGON7eoGIgIiAiNLMnN0GHvVgesvWcBB7AAAAAElFTkSuQmCC"};
